
import { API } from "../constants/api";
import {
  axiosGetWithToken,
  axiosPostWithToken,
  axiosDelete,
} from "../services/apiServices";
import { ERROR_ALERT, SUCCESS_ALERT } from "./commonAction";

export const USER_TAGS_LIST = "USER_TAGS_LIST";
export const SET_ITEMS_PER_PAGE = "SET_ITEMS_PER_PAGE";
export const CHANGE_CURRENT_PAGE = "CHANGE_CURRENT_PAGE";
export const LOADING = "LOADING";
export const SEARCH_TAGS = "SEARCH_TAGS";


export const getTags = () => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;

    axiosGetWithToken(
      `${API.USER_TAGS_LIST}`,token
    ).then((res) => {
      if (res.data.status_code === 200) {
        dispatch({
          type: USER_TAGS_LIST,
          payload: res.data.data,
        });
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload: "Something went wrong. Error fetching data.",
        });
      }
    });
  };
};

export const addTags = (data, refresh, option, id) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
    const payload = {
      name:data
    }

    const url = option === "add" ? API.USER_TAGS_CREATE : `${API.USER_TAGS_UPDATE}${id}/`
    axiosPostWithToken(url, payload, token).then((res) => {
      if (res.data.status_code === 200) {
        dispatch({
          type: LOADING,
        });
        refresh();
        dispatch({
          type: SUCCESS_ALERT,
          payload: option === "add"  ? "User Tag added Successfully" : "User Tag Updated Successfully",
        });
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload:
            res.data.data.message || "Something went wrong. Error adding User.",
        });
      }
    });
  };
};

export const removeTags = (id, refresh) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
   
    axiosDelete(`${API.USER_TAGS_REMOVE}/${id}/`, token).then((res) => {
      if (res.data.status_code === 200) {
        dispatch({
          type: LOADING,
        });
        refresh();
        dispatch({
          type: SUCCESS_ALERT,
          payload: "User Tag deleted Successfully",
        });
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload:
            res.data.data.message || "Something went wrong. Error adding User.",
        });
      }
    });
  };
};